import {useTranslation} from 'react-i18next';

import {EmpionButton} from '../../../../components/EmpionButton/EmpionButton';

interface OnboardingCompleteProps {
  formik: any;
}

export default function OnboardingComplete({formik}: OnboardingCompleteProps) {
  const {t} = useTranslation();

  return (
    <>
      <EmpionButton
        sx={{
          mt: 5,
          width: {xs: '100%', md: 'auto'},
        }}
        type='submit'
        disabled={formik.isSubmitting}
      >
        {t('shared.formButtons.savePreferences')}
      </EmpionButton>
    </>
  );
}
